const StylePanelAsync = () => import('./StylePanel.vue');
const VariablePanelAsync = () => import('./VariablePanel.vue');
const EventPanelAsync = () => import('./EventPanel.vue');

export { VariablePanelAsync, StylePanelAsync, EventPanelAsync };
export * from './utils';
export * from './components';
